import { SOUND_CREATOR_V2_ADDRESS } from '../../abi/sound-creator-v2.mjs';
import { createTieredEditionArgs } from '../../helpers/createTieredEditionArgs.mjs';

async function estimateGasCreateTieredEdition(client, args) {
  const { owner } = args;
  return client.estimateContractGas({
    ...createTieredEditionArgs(args),
    functionName: "create",
    address: SOUND_CREATOR_V2_ADDRESS,
    account: owner
  });
}

export { estimateGasCreateTieredEdition };
